export default "__VITE_ASSET__dr9hN9Sj__"